__turbopack_context__.v({
  "address": "slideInMenu-module-scss-module__xqSB5G__address",
  "addressLabel": "slideInMenu-module-scss-module__xqSB5G__addressLabel",
  "addressWrapper": "slideInMenu-module-scss-module__xqSB5G__addressWrapper",
  "animatedContainer": "slideInMenu-module-scss-module__xqSB5G__animatedContainer",
  "backdrop": "slideInMenu-module-scss-module__xqSB5G__backdrop",
  "closeAnimation": "slideInMenu-module-scss-module__xqSB5G__closeAnimation",
  "container": "slideInMenu-module-scss-module__xqSB5G__container",
  "menuItemsContainer": "slideInMenu-module-scss-module__xqSB5G__menuItemsContainer",
  "menuWrapper": "slideInMenu-module-scss-module__xqSB5G__menuWrapper",
  "open": "slideInMenu-module-scss-module__xqSB5G__open",
  "openAnimation": "slideInMenu-module-scss-module__xqSB5G__openAnimation",
  "show": "slideInMenu-module-scss-module__xqSB5G__show",
  "wrapper": "slideInMenu-module-scss-module__xqSB5G__wrapper",
});
